module.exports = __webpack_public_path__ + "static/media/guide_desktop_01.b101912e.svg";